import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-07e7c13f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "学校", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所有学校", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "频道", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所有频道", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所有设备", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_School = _resolveComponent("School")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_Histogram = _resolveComponent("Histogram")!
  const _component_CircleCheck = _resolveComponent("CircleCheck")!
  const _component_DataBoard = _resolveComponent("DataBoard")!
  const _component_DataAnalysis = _resolveComponent("DataAnalysis")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu, {
        router: "",
        "unique-opened": "",
        collapse: _ctx.isShow,
        "default-active": _ctx.route.path
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: "/",
            class: "logo"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "1" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_School)
                ]),
                _: 1
              }),
              _hoisted_2
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/middle/school" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_OfficeBuilding)
                    ]),
                    _: 1
                  }),
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "2" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Histogram)
                ]),
                _: 1
              }),
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/middle/channel" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_CircleCheck)
                    ]),
                    _: 1
                  }),
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "3" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DataBoard)
                ]),
                _: 1
              }),
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/middle/zhanshi" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataAnalysis)
                    ]),
                    _: 1
                  }),
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["collapse", "default-active"])
    ]),
    _: 1
  }))
}